import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'helpers/cx'

import { AriaLiveMessage } from 'js/components/AriaLive'
import Text from 'js/components/Text/Text'
import Textfield from 'js/components/Textfield/Textfield'
import { useViewerStore } from 'js/lib/stores'
import PageEditorContext from 'js/page/PageEditor/PageEditorContext'
import useWidgets from 'js/page/Widget/helpers/getWidgets'
import pageEditorIncludesWidget from 'js/page/Widget/helpers/pageEditorIncludesWidget'

import styles from './WidgetPicker.module.css'

const WidgetPicker = ({ onAddWidget, ...rest }) => {
    const { group, rows } = useContext(PageEditorContext)

    const handleAddWidget = (type) => {
        onAddWidget(type)
    }

    const [searchValue, setSearchValue] = useState('')
    const handleChangeSearch = (evt) => {
        setSearchValue(evt.target.value)
    }

    const { t } = useTranslation()

    const hasTitleWidget = pageEditorIncludesWidget('pageTitle', rows)
    const isSubEditor = useViewerStore((state) => state.viewer?.isSubEditor)

    const widgets = useWidgets(!!group)

    const filteredWidgets = widgets
        .filter((widget) => !(hasTitleWidget && widget.value === 'pageTitle'))
        .filter((widget) => isSubEditor || widget.value !== 'html')
        .filter(
            (widget) =>
                widget.label
                    .toLowerCase()
                    .indexOf(searchValue.toLowerCase()) !== -1,
        )

    return (
        <div
            className={cx(
                styles.wrapper,
                !(widgets.length > 3) && styles.cols3,
            )}
            {...rest}
        >
            <Textfield
                className={styles.filter}
                borderStyle="none"
                placeholder={t('page.search-widget')}
                value={searchValue}
                onChange={handleChangeSearch}
            />
            <AriaLiveMessage
                message={
                    filteredWidgets.length
                        ? `${filteredWidgets.length}`
                        : t('page.widgets-not-found')
                }
            />
            {filteredWidgets.length ? (
                <div className={styles.options}>
                    {filteredWidgets.map((widget) => (
                        <button
                            key={widget.value}
                            type="button"
                            onClick={() => handleAddWidget(widget.value)}
                            className={styles.option}
                            data-testid={`widget-option-${widget.value}`}
                        >
                            <div className={styles.icon}>{widget.icon}</div>
                            <span className={styles.name}>{widget.label}</span>
                        </button>
                    ))}
                </div>
            ) : (
                <Text
                    textAlign="center"
                    size="small"
                    style={{ padding: '16px' }}
                >
                    {t('page.widgets-not-found')}
                </Text>
            )}
        </div>
    )
}

export default WidgetPicker
